/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path pages/kpiworkflowsteps
 * @description KPI workflow steps
 *
 * @section 4.1.9.2
 *
 *
 */
import { Container } from "@material-ui/core";
import { t } from "i18next";
import React, { useState } from "react";
import { useAppContext } from "./../../context/AppCtxProvider";
import AlertMessage from "./../../ui/components/AlertMessage";
import ResizeWrapper, {
  LeftWrapper,
  RightWrapper,
} from "./../../ui/components/ResizeWrapper";
import WorkflowSteps from "./../../uicomponents/view/WorkflowSteps";
import { makeThemedStyles } from "./../../viewcomponents/utils";
import WorkflowKpiList from "./../kpisapproval/WorkflowKpiList";
import ListThemes from "./../kpisapproval/themes";
import ComponentThemes from "./themes";
const useStyles = makeThemedStyles("", (theme) => ({
  container: {
    display: "flex",
    background: "white",
    margin: 0,
    padding: "0px !important",
    maxWidth: "100%",
    width: "100%",
  },
  Left: { background: "rgb(237, 243, 244)", minHeight: "100vh" },
}));
const Kpiworkflowsteps = () => {
  const classes = useStyles();
  const ctx = useAppContext();
  const currentState = !!localStorage.getItem("fullWidth");
  const [fullWidth, setFullWidth] = useState(currentState);
  const [selectedRow, setSelectedRow] = useState({});

  if (!ctx.modelId) {
    return <AlertMessage severity="error">{t("Access denied")}</AlertMessage>;
  }
  return (
    <Container className={classes.container}>
      <ResizeWrapper>
        <LeftWrapper fullWidth={fullWidth}>
          <div className={classes.Left}>
            <ListThemes.WorkflowKpiList>
              <WorkflowKpiList
                componentData={{
                  query: `[${ctx.fullModelId}].SubObjects`,
                  criteria: 'typename="KPI"',
                  attributes:
                    'id,name,unit(series="ACT"), unitname(series="ACT"), typename,value(series="JS_ATTR", period="firstforseries", as="translations")',
                  values: [
                    {
                      series: "ACT",
                      as: "actual",
                    },
                    {
                      series: "TAR",
                      as: "target",
                    },
                  ],
                  url: "${ctx.rootUrl}/kpiworkflowsteps/${item.id}",
                  enabled: true,
                }}
                setSelectedRowIs={setSelectedRow}
              />
            </ListThemes.WorkflowKpiList>
          </div>
        </LeftWrapper>

        <RightWrapper fullWidth={fullWidth} setWidth={setFullWidth}>
          <div>
            <ComponentThemes.KpiWorkflowSteps>
              <WorkflowSteps
                componentData={{
                  title: `${t("Details")}`,
                  variant: "h1",
                }}
                isKpi
                selectedRow={selectedRow}
              />
            </ComponentThemes.KpiWorkflowSteps>
          </div>
        </RightWrapper>
      </ResizeWrapper>
    </Container>
  );
};
export default Kpiworkflowsteps;
